module.exports = __webpack_public_path__ + "img/one.07082a0e.jpg";